import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { fetchEntity } from '@classpass/saga-tools';
import { call, all, put, select, spawn } from 'redux-saga/effects';
import { getForApi } from 'helpers/utmValues';
import { Validator as paymentValidator } from 'components/PaymentMethods/Validator';
import { planById, msaOfferById, createSubscriptionCache } from 'redux/saga/entities/bound';
import { ec, ga } from 'helpers/multitrack';
import { deepExtract } from 'helpers/deep';
import { getFormValues } from 'helpers/forms';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { dimensions, GoogleAnalytics } from 'components/GoogleAnalytics/GoogleAnalytics';
import { trackGoogleTagManagerEvent } from 'components/GoogleTagManager/GoogleTagManager';
import { selectActivePaymentMethod } from 'components/PaymentMethodSelector/PaymentMethodSelector.reducer';
import { STRIPE_PAYMENT_METHODS } from 'components/PaymentMethodSelector/PaymentMethodSelector.constants';
import { userId as selectUserId } from 'redux/saga/selectors';
import { selectCart } from 'redux/modules/cart';
import { getTokenPromise } from 'components/PaymentMethods/withStripeElements';
import { ApiError } from 'components/Errors/ApiError';
import { getUserLocation, gtmSafeRedirect } from 'redux/saga/helpers';
import { msaIdToAlias } from 'constants/msas';
import { baseSignupValidator } from './BaseSignupValidator';
import { setActiveProduct, selectActiveProduct } from '../Products.reducer';
export var getPurchaseFormValues = getFormValues('purchase'); // This object maps between field on the purchase result and GTM data layer variables

var GTM_RESULT_MAPPING = {
  purchaseChargeAmount: 'charge_amount',
  currency: 'currency_code',
  giftRedemption: 'gift_redemption',
  msaId: 'msa_id',
  msaOfferId: 'msa_offer_id',
  planCode: 'plan_code',
  purchasePlanId: 'plan_id',
  planTierName: 'plan_tier_name',
  purchasePlanPrice: 'plan_price',
  taxAmount: 'tax_amount',
  purchaseTransactionId: 'id',
  offerName: 'offer_name',
  offerId: 'offer_id',
  promotionAlias: 'promotion_alias',
  purchasePromotionId: 'promotion_id',
  transactionId: 'id',
  transactionTotal: 'charge_amount',
  price: 'charge_amount',
  name: 'plan_code',
  sku: 'plan_id'
};
export var BaseProduct =
/*#__PURE__*/
function () {
  function BaseProduct() {
    _classCallCheck(this, BaseProduct);
  }

  _createClass(BaseProduct, null, [{
    key: "activate",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function activate(productData) {
      return regeneratorRuntime.wrap(function activate$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!this || !this.key)) {
                _context.next = 2;
                break;
              }

              throw new Error('Activate can only be called from the context of a product with a key.');

            case 2:
              _context.next = 4;
              return put(setActiveProduct(this.key, productData));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, activate, this);
    })
  }, {
    key: "getProductData",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function getProductData() {
      return regeneratorRuntime.wrap(function getProductData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return select(selectActiveProduct);

            case 2:
              return _context2.abrupt("return", _context2.sent.data);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, getProductData);
    })
  }, {
    key: "postPurchase",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function postPurchase(result) {
      return regeneratorRuntime.wrap(function postPurchase$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(BaseProduct.trackPurchaseSuccess, result);

            case 2:
              _context3.next = 4;
              return call(gtmSafeRedirect, '/welcome/refer');

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, postPurchase);
    })
  }, {
    key: "submitIdealPurchaseCache",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function submitIdealPurchaseCache(client, userId, payload, _ref) {
      var stripePromise, _ref2, cacheKey, paymentSource, redirectUrl;

      return regeneratorRuntime.wrap(function submitIdealPurchaseCache$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              stripePromise = _ref.stripePromise;
              _context4.next = 3;
              return call(fetchEntity, createSubscriptionCache, [client, userId, payload]);

            case 3:
              _ref2 = _context4.sent;
              cacheKey = _ref2.cache_key;
              _context4.next = 7;
              return call(stripePromise, {
                cacheKey: cacheKey,
                userId: userId
              });

            case 7:
              paymentSource = _context4.sent;

              if (!paymentSource) {
                _context4.next = 13;
                break;
              }

              redirectUrl = paymentSource.redirectUrl;
              _context4.next = 12;
              return call(BaseProduct.trackIdealPurchaseCompleted);

            case 12:
              window.location.assign(redirectUrl);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, submitIdealPurchaseCache);
    })
  }, {
    key: "submitPurchaseData",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function submitPurchaseData(client, currentUserId, _ref3, consents) {
      var stripeTokenPromiseKey, formData, _ref4, _ref5, stripePromiseToCall, activeLocation, activePaymentMethod, conversion, payload, paymentToken, payloadWithPaymentToken, _ref6, msaOfferId, msaOffer, _ref7, _ref7$code, errorCode, _ref7$details, errorDetails, _ref7$message, errorMessage;

      return regeneratorRuntime.wrap(function submitPurchaseData$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              stripeTokenPromiseKey = _ref3.stripeTokenPromiseKey, formData = _objectWithoutProperties(_ref3, ["stripeTokenPromiseKey"]);
              _context5.next = 3;
              return all([call(getTokenPromise, stripeTokenPromiseKey), call(getUserLocation, client), select(selectActivePaymentMethod)]);

            case 3:
              _ref4 = _context5.sent;
              _ref5 = _slicedToArray(_ref4, 3);
              stripePromiseToCall = _ref5[0];
              activeLocation = _ref5[1];
              activePaymentMethod = _ref5[2];
              _context5.next = 10;
              return call(getForApi);

            case 10:
              conversion = _context5.sent;
              payload = _objectSpread({
                billing_info: {
                  address: {
                    country: formData.countryCode,
                    postal_code: formData.ccZip && String(formData.ccZip)
                  }
                },
                consents: consents,
                conversion: conversion
              }, activeLocation && {
                gls_location_id: deepExtract('location.id', activeLocation)
              }, formData.friendbuyCode && {
                friendbuy_referral_code: formData.friendbuyCode
              }, formData.giftCode && {
                redemption_code: formData.giftCode
              }, formData.promoCode && {
                promotion_code: formData.promoCode
              }, formData.msaOfferId ? {
                msa_offer_id: parseInt(formData.msaOfferId, 10)
              } : {
                plan_id: parseInt(formData.planId, 10),
                msa_id: parseInt(formData.msaId, 10)
              }, formData.corporateDetails && formData.corporateDetails.partner && {
                corporate: _defineProperty({}, formData.corporateDetails.partner, {
                  user_token: formData.corporateDetails.token,
                  initial_url: formData.corporateDetails.initial_url
                })
              });
              _context5.prev = 12;

              if (!(activePaymentMethod === STRIPE_PAYMENT_METHODS.IDEAL)) {
                _context5.next = 17;
                break;
              }

              _context5.next = 16;
              return call(BaseProduct.submitIdealPurchaseCache, client, currentUserId, payload, {
                stripePromise: stripePromiseToCall
              });

            case 16:
              return _context5.abrupt("return", _context5.sent);

            case 17:
              _context5.next = 19;
              return call(stripePromiseToCall);

            case 19:
              paymentToken = _context5.sent;
              payloadWithPaymentToken = _objectSpread({}, payload, paymentToken && paymentToken.source ? {
                stripe_source: paymentToken.source
              } : {
                payment_token: paymentToken
              });
              _context5.next = 23;
              return call(client.subscription.create, currentUserId, payloadWithPaymentToken);

            case 23:
              return _context5.abrupt("return", _context5.sent);

            case 26:
              _context5.prev = 26;
              _context5.t0 = _context5["catch"](12);
              _context5.next = 30;
              return call(BaseProduct.getProductData);

            case 30:
              _ref6 = _context5.sent;
              msaOfferId = _ref6.msaOfferId;
              _context5.next = 34;
              return select(msaOfferById.data, msaOfferId);

            case 34:
              msaOffer = _context5.sent;
              _ref7 = _context5.t0 || {}, _ref7$code = _ref7.code, errorCode = _ref7$code === void 0 ? 'Unknown error code' : _ref7$code, _ref7$details = _ref7.details, errorDetails = _ref7$details === void 0 ? 'Unknown error details' : _ref7$details, _ref7$message = _ref7.message, errorMessage = _ref7$message === void 0 ? 'Unknown error message' : _ref7$message;
              _context5.next = 38;
              return all([call(ec, 'Membership Purchase Errors', {
                details: errorDetails,
                message: errorMessage,
                code: errorCode,
                user_id: currentUserId,
                plan_id: formData.planId,
                msa_id: formData.msaId,
                promotion_alias: msaOffer && msaOffer.promotion_alias,
                payment_method: activePaymentMethod
              }), call(trackGoogleTagManagerEvent, {
                event: 'gaEvent',
                eventCategory: 'Membership Purchase',
                eventAction: 'Membership Purchase Errors',
                eventLabel: "".concat(activePaymentMethod, ",").concat(errorCode, "-").concat(errorMessage),
                eventNI: true
              })]);

            case 38:
              throw _context5.t0;

            case 39:
            case "end":
              return _context5.stop();
          }
        }
      }, submitPurchaseData, null, [[12, 26]]);
    })
  }, {
    key: "trackIdealPurchaseCompleted",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackIdealPurchaseCompleted() {
      var _ref8, msaId, planId, msaOfferId, giftCode, _ref9, _ref10, plan, msaOffer;

      return regeneratorRuntime.wrap(function trackIdealPurchaseCompleted$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return select(getPurchaseFormValues);

            case 2:
              _ref8 = _context6.sent;
              msaId = _ref8.msaId;
              planId = _ref8.planId;
              msaOfferId = _ref8.msaOfferId;
              giftCode = _ref8.giftCode;
              _context6.next = 9;
              return all([select(planById.data, planId), select(msaOfferById.data, msaOfferId)]);

            case 9:
              _ref9 = _context6.sent;
              _ref10 = _slicedToArray(_ref9, 2);
              plan = _ref10[0];
              msaOffer = _ref10[1];
              _context6.next = 15;
              return all([call(ec, 'iDEAL Purchase - Complete', {
                plan_id: planId,
                plan_code: plan && plan.plan_code,
                promotion_alias: msaOffer && msaOffer.promotion_alias,
                gift_code: giftCode,
                success: true,
                msa_id: msaId
              }), call(ga, 'Membership Purchase', 'iDEAL Purchase Success', planId)]);

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, trackIdealPurchaseCompleted);
    })
    /* eslint-disable no-unused-vars, no-empty-function */

  }, {
    key: "trackPurchaseFailure",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackPurchaseFailure() {
      return regeneratorRuntime.wrap(function trackPurchaseFailure$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
            case "end":
              return _context7.stop();
          }
        }
      }, trackPurchaseFailure);
    })
    /* eslint-enable no-unused-vars, no-empty-function */

  }, {
    key: "trackPurchaseLoad",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackPurchaseLoad() {
      var _ref11, msaId, planId, msaOfferId, _ref12, _ref13, userId, cart, plan, msaOffer;

      return regeneratorRuntime.wrap(function trackPurchaseLoad$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return select(getPurchaseFormValues);

            case 2:
              _ref11 = _context8.sent;
              msaId = _ref11.msaId;
              planId = _ref11.planId;
              msaOfferId = _ref11.msaOfferId;
              _context8.next = 8;
              return all([select(selectUserId), select(selectCart), select(planById.data, planId), select(msaOfferById.data, msaOfferId)]);

            case 8:
              _ref12 = _context8.sent;
              _ref13 = _slicedToArray(_ref12, 4);
              userId = _ref13[0];
              cart = _ref13[1];
              plan = _ref13[2];
              msaOffer = _ref13[3];
              _context8.next = 16;
              return all([spawn(ec, 'Purchase - Start', {
                plan_id: planId,
                plan_code: plan && plan.plan_code,
                promotion_alias: msaOffer && msaOffer.promotion_alias
              }), spawn(GoogleAnalytics.sendPageView, '/signup/v2/membership/start'), spawn(trackGoogleTagManagerEvent, {
                event: 'view_cart',
                msaId: msaId,
                userId: userId,
                planId: planId,
                planName: plan && plan.name,
                offerName: msaOffer && msaOffer.offer_name,
                msaOfferId: msaOfferId,
                price: cart.subTotal
              })]);

            case 16:
            case "end":
              return _context8.stop();
          }
        }
      }, trackPurchaseLoad);
    })
  }, {
    key: "trackPurchaseSuccess",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackPurchaseSuccess(result) {
      var _ref14, msaId, planId, msaOfferId, giftCode, _ref15, _ref16, plan, msaOffer, gtmDataObject, userId, msaAlias, calls;

      return regeneratorRuntime.wrap(function trackPurchaseSuccess$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return select(getPurchaseFormValues);

            case 2:
              _ref14 = _context9.sent;
              msaId = _ref14.msaId;
              planId = _ref14.planId;
              msaOfferId = _ref14.msaOfferId;
              giftCode = _ref14.giftCode;
              _context9.next = 9;
              return all([select(planById.data, planId), select(msaOfferById.data, msaOfferId)]);

            case 9:
              _ref15 = _context9.sent;
              _ref16 = _slicedToArray(_ref15, 2);
              plan = _ref16[0];
              msaOffer = _ref16[1];
              gtmDataObject = Object.keys(GTM_RESULT_MAPPING).filter(function (gtmKey) {
                return result[GTM_RESULT_MAPPING[gtmKey]];
              }).reduce(function (data, gtmKey) {
                return Object.assign(data, _defineProperty({}, gtmKey, gtmKey === 'currency' ? result[GTM_RESULT_MAPPING[gtmKey]].toUpperCase() : result[GTM_RESULT_MAPPING[gtmKey]]));
              }, {
                event: 'successful_purchase'
              });
              _context9.next = 16;
              return select(selectUserId);

            case 16:
              userId = _context9.sent;
              msaAlias = msaIdToAlias(result.msa_id);
              calls = [call(trackGoogleTagManagerEvent, _objectSpread({}, gtmDataObject, {
                userId: userId,
                msaName: msaAlias
              })), call(GoogleAnalytics.sendPageView, '/signup/v2/membership/purchase', _defineProperty({}, dimensions.USER_TYPE, 'registered')), call(ec, 'Purchase - Complete', {
                plan_id: planId,
                plan_code: plan && plan.plan_code,
                promotion_alias: msaOffer && msaOffer.promotion_alias,
                gift_code: giftCode,
                success: true,
                msa_id: msaId
              }), call(trackOptimizelyEvent, 'successful_subscription_purchase'), call(trackOptimizelyEvent, 'successful_overall_purchase')];
              _context9.next = 21;
              return all(calls);

            case 21:
            case "end":
              return _context9.stop();
          }
        }
      }, trackPurchaseSuccess);
    })
    /* eslint-disable no-unused-vars, no-empty-function */

  }, {
    key: "trackSignupFailure",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackSignupFailure() {
      return regeneratorRuntime.wrap(function trackSignupFailure$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
            case "end":
              return _context10.stop();
          }
        }
      }, trackSignupFailure);
    })
  }, {
    key: "trackSignupLoad",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackSignupLoad() {
      return regeneratorRuntime.wrap(function trackSignupLoad$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
            case "end":
              return _context11.stop();
          }
        }
      }, trackSignupLoad);
    })
  }, {
    key: "trackSignupSuccess",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackSignupSuccess() {
      return regeneratorRuntime.wrap(function trackSignupSuccess$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
            case "end":
              return _context12.stop();
          }
        }
      }, trackSignupSuccess);
    })
    /* eslint-enable no-unused-vars, no-empty-function */

  }]);

  return BaseProduct;
}();

_defineProperty(BaseProduct, "validator", paymentValidator);

_defineProperty(BaseProduct, "signupValidator", baseSignupValidator);

_defineProperty(BaseProduct, "errorMessager", function (err) {
  return ApiError.messageForDisplay([err], ApiError.billingErrorReducer);
});